import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Meta from 'vue-meta';

import vueSmoothScroll from 'vue-smooth-scroll'

import localizeFilter from '@/filters/localize.filter'

import Scroll from '@/directives/Scroll'

Vue.config.productionTip = true

Vue.use(vueSmoothScroll)
Vue.use(Meta);

Vue.filter('localize', localizeFilter)

Vue.directive('scroll', Scroll);

new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')
